export default {
  /** Show text for cleaning bricks from mortar */
  BRICKS_AND_MORTAR_CLEANING_QUESTION: '2.6.7',
  /** Hide equivalent number from this version and onwards */
  HIDE_EQUIVALENT_NUMBERS: '2.8.4',
}
